<template>
    <vx-card title="Добавление настроек расчета коэффов микробиддинга" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.subDaysGroups" :danger="!!errors.subDaysGroups"
                        :danger-text="errors.subDaysGroups" autocomplete="off" label="Группа дней подписки"
                        class="mt-1 w-full required" />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.daysCount" :danger="!!errors.daysCount" :danger-text="errors.daysCount"
                        autocomplete="off" label="Кол-во дней для расчета" class="mt-1 w-full required" type="number" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Страны по дням подписки</label>
                    <v-select :options="dicts.countries" multiple label="name" value="iso2"
                        placeholder="Выберите страны" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.countriesIso2 }" v-model="form.countriesIso2DaysGroup"
                        :reduce="(a) => a.iso2">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Страны по сайтам </label>
                    <v-select :disabled="isFillSameCountries" :options="dicts.countries" multiple label="name"
                        value="iso2" placeholder="Выберите страны" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.countriesIso2 }" v-model="form.countriesIso2Sites"
                        :reduce="(a) => a.iso2">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameCountries">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <vs-input v-model="form.clicksLimitDaysGroup" :danger="!!errors.clicksLimitDaysGroup"
                        :danger-text="errors.clicksLimitDaysGroup" autocomplete="off"
                        label="Лимит кликов по дням подписки" class="mt-1 w-full required" />
                </div>
            </div>
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <vs-input :disabled="isFillSameClicksLimit" v-model="form.clicksLimitSites"
                        :danger="!!errors.clicksLimitSites" :danger-text="errors.clicksLimitSites" autocomplete="off"
                        label="Лимит кликов по сайтам" class="mt-1 w-full required" />
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameClicksLimit">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <vs-input v-model="form.leadsLimitDaysGroup" :danger="!!errors.leadsLimitDaysGroup"
                        :danger-text="errors.leadsLimitDaysGroup" autocomplete="off"
                        label="Лимит конверсий по дням подписки" class="mt-1 w-full required" />
                </div>
            </div>
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <vs-input :disabled="isFillSameLeadsLimit" v-model="form.leadsLimitSites"
                        :danger="!!errors.leadsLimitSites" :danger-text="errors.leadsLimitSites" autocomplete="off"
                        label="Лимит конверсий по сайтам" class="mt-1 w-full required" />
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameLeadsLimit">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Тематики по дням подписки </label>
                    <v-select :options="dicts.subjectAdTags" multiple label="name" value="id"
                        placeholder="Выберите тематики" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.themesDaysGroup }" v-model="form.themesDaysGroup"
                        :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Тематики по сайтам </label>
                    <v-select :disabled="isFillSameSubjectAdTags" :options="dicts.subjectAdTags" multiple label="name"
                        value="id" placeholder="Выберите тематики по сайтам" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.themesSites }" v-model="form.themesSites"
                        :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameSubjectAdTags">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> SSP по дням подписки </label>
                    <v-select :options="dicts.sspTypes" multiple label="name" value="id" placeholder="Выберите SSP"
                        class="w-full" v-bind:class="{ 'select-error': !!errors.sspTypesDaysGroup }"
                        v-model="form.sspTypesDaysGroup" :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> SSP по сайтам</label>
                    <v-select :disabled="isFillSameSspTypes" :options="dicts.sspTypes" multiple label="name" value="id"
                        placeholder="Выберите SSP" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.sspTypesSites }" v-model="form.sspTypesSites"
                        :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameSspTypes">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>

        <h6 class="mt-6 mb-3">Настройки применения</h6>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Страны</label>
                    <v-select :options="dicts.countries" :disabled="isFillSameCountriesApply" multiple label="name" value="iso2"
                        placeholder="Выберите страны" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.countriesIso2Apply }" v-model="form.countriesIso2Apply"
                        :reduce="(a) => a.iso2">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameCountriesApply">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Тематики </label>
                    <v-select :options="dicts.subjectAdTags" :disabled="isFillSameSubjectAdTagsApply" multiple label="name" value="id"
                        placeholder="Выберите тематики" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.themesApply }" v-model="form.themesApply"
                        :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameSubjectAdTagsApply">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/5">
                <div class="mt-1">
                    <label class="vs-input--label"> SSP </label>
                    <v-select :options="dicts.sspTypes" multiple :disabled="isFillSameSspTypesApply" label="name" value="id" placeholder="Выберите SSP"
                        class="w-full" v-bind:class="{ 'select-error': !!errors.sspTypesApply }"
                        v-model="form.sspTypesApply" :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-10">
                    <vs-checkbox v-model="isFillSameSspTypesApply">
                        Заполнять также
                    </vs-checkbox>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveJob()" type="filled"> Сохранить </vs-button>
        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'microbidding-calc-jobs-subscription-days-edit',
    props: ['id'],
    data() {
        return {
            microBiddingCalcJob: undefined,
            isFillSameCountries: false,
            isFillSameClicksLimit: false,
            isFillSameLeadsLimit: false,
            isFillSameSubjectAdTags: false,
            isFillSameSspTypes: false,
            isFillSameCountriesApply: false,
            isFillSameSubjectAdTagsApply: false,
            isFillSameSspTypesApply: false,

            form: {
                daysCount: undefined,
                subDaysGroups: undefined,

                clicksLimitDaysGroup: undefined,
                leadsLimitDaysGroup: undefined,
                countriesIso2DaysGroup: undefined,
                themesDaysGroup: undefined,
                sspTypesDaysGroup: undefined,

                clicksLimitSites: undefined,
                leadsLimitSites: undefined,
                countriesIso2Sites: undefined,
                themesSites: undefined,
                sspTypesSites: undefined,

                countriesIso2Apply: undefined,
                themesApply: undefined,
                sspTypesApply: undefined,
            },
            dicts: {
                countries: [],
                subjectAdTags: [],
                sspTypes: [],
            },
            errors: {
                clicksLimit: '',
                leadsLimit: '',
                countriesIso2: '',
                daysCount: '',
                themes: ''
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.axios
                .all([this.axios.get('microBiddingCalcJobs/dicts')])
                .then(axios.spread((dicts) => {
                    this.dicts = dicts.data;
                }))
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки справочников.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    // this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('microBiddingCalcJobs/' + this.id)])
                .then(
                    axios.spread((microBiddingCalcJob) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.microBiddingCalcJob = microBiddingCalcJob.data;
                        this.form = microBiddingCalcJob.data;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки настроек.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveJob() {
            this.form.countriesIso2Sites = this.isFillSameCountries ? this.form.countriesIso2DaysGroup : this.form.countriesIso2Sites;
            this.form.clicksLimitSites = this.isFillSameClicksLimit ? this.form.clicksLimitDaysGroup : this.form.clicksLimitSites;
            this.form.leadsLimitSites = this.isFillSameLeadsLimit ? this.form.leadsLimitDaysGroup : this.form.leadsLimitSites;
            this.form.themesSites = this.isFillSameSubjectAdTags ? this.form.themesDaysGroup : this.form.themesSites;
            this.form.sspTypesSites = this.isFillSameSspTypes ? this.form.sspTypesDaysGroup : this.form.sspTypesSites;
            this.form.countriesIso2Apply = this.isFillSameCountriesApply ? this.form.countriesIso2DaysGroup : this.form.countriesIso2Apply;
            this.form.themesApply = this.isFillSameSubjectAdTagsApply ? this.form.themesDaysGroup : this.form.themesApply;
            this.form.sspTypesApply = this.isFillSameSspTypesApply ? this.form.sspTypesDaysGroup : this.form.sspTypesApply;

            var errorFields = this.validateFields();
            if (errorFields) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: errorFields,
                    color: 'warning'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.form, { id: this.id });
            this.$axios({
                method: 'PUT',
                url: 'microBiddingCalcJobs/' + this.id,
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Настройки успешно сохранены',
                        color: 'success'
                    });
                    this.$router.push('/microbidding-calc-jobs');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка!',
                        text: err.response.data,
                        color: 'danger'
                    });
                }
            });
        },
        cancelEdit() {
            this.$router.push('/microbidding-calc-jobs');
        },
        validateFields() {
            if (!this.form.clicksLimitSites) {
                return 'Введите лимит кликов по сайтам';
            }
            if (!this.form.clicksLimitDaysGroup) {
                return 'Введите лимит кликов по дням подписки';
            }

            if (!this.form.leadsLimitSites) {
                return 'Введите лимит конверсий по сайтам';
            }
            if (!this.form.leadsLimitDaysGroup) {
                return 'Введите лимит конверсий по дням подписки';
            }

            if (!this.form.subDaysGroups) {
                return 'Введите группы дней подписки';
            }
            if (!this.form.daysCount) {
                return 'Введите кол-во дней для рассчета';
            }

        },
    },
    watch: {
        isFillSameCountries: function (value) {
            this.form.countriesIso2Sites = value 
            ? this.form.countriesIso2DaysGroup 
            : this.form.countriesIso2Sites;         
        },
        isFillSameClicksLimit: function (value) {
            this.form.clicksLimitSites = value 
            ? this.form.clicksLimitDaysGroup 
            : this.form.clicksLimitSites;
        },
        isFillSameLeadsLimit: function (value) {            
            this.form.leadsLimitSites = value 
            ? this.form.leadsLimitDaysGroup 
            : this.form.leadsLimitSites;
        },
        isFillSameSubjectAdTags: function (value) {            
            this.form.themesSites = value 
            ? this.form.themesDaysGroup 
            : this.form.themesSites;
        },
        isFillSameSspTypes: function (value) {            
            this.form.sspTypesSites = value 
            ? this.form.sspTypesDaysGroup 
            : this.form.sspTypesSites;
        },
        isFillSameCountriesApply: function (value) {
            this.form.countriesIso2Apply = value 
            ? this.form.countriesIso2DaysGroup 
            : this.form.countriesIso2Apply;         
        },
        isFillSameSubjectAdTagsApply: function (value) {            
            this.form.themesApply = value 
            ? this.form.themesDaysGroup 
            : this.form.themesApply;
        },
        isFillSameSspTypesApply: function (value) {            
            this.form.sspTypesApply = value 
            ? this.form.sspTypesDaysGroup
            : this.form.sspTypesApply;
        },
    },
    mounted() {
        this.loadDicts();
        this.loadData();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Редактировать расчет по дням подписки';
    }
};
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>